import { Button } from '@material-ui/core';
import GitHubIcon from '@material-ui/icons/GitHub';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import React from 'react';

const Project = ({title, description, image, github, preview }) => {
    return (
        <>
            <div className="card_container">
                <div className='card_img' style={{backgroundImage:`url('${image}')`}}>
                </div>
                <div className="card_info">
                    <div className="card_info_sub_aria">
                        <h1 className='text-2xl font-bold mb-3'>{title}</h1>
                        <p className='mb-2'>{description}</p>
                        <div className="card_info_btn_container">
                            <a href={`https://github.com/mdtaju${github}`} target='_blank' rel='noreferrer'>
                                <Button 
                                    className='card_info_btn card_info_btn_left'
                                    endIcon={<GitHubIcon />}
                                >
                                    Source Code
                                </Button>
                            </a>
                            <a href={preview} target='_blank' rel='noreferrer'>
                                <Button 
                                    className='card_info_btn card_info_btn_right'
                                    endIcon={<ExitToAppIcon />}
                                >
                                    Live Preview
                                </Button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Project;